import request from "@/network/request"
// 获取宣教详情
export function propagateDetails(data) {
	return request({
		url: "/sclm/apply/app/scan/educationDetail",
		method: 'post',
		data,
	});
}

// 宣教列表
export function propagateList(data) {
	return request({
		url: "/sclm/apply/app/scan/educationList",
		method: 'post',
		data,
	});
}
